import {
  getAllOffersForMFACustomerUrl,
  getOffersForNonMFACustomerByIdUrl,
  getOffersForNonMFACustomerUrl,
  getPersonalOfferLetterDataUrl,
  getUrlToSubmitMfaCustomerOffer,
  getUrlToSubmitRecommendedImplementOfferEnquiry,
  getprevouslySubmittedNonMFAoffersURL,
  nonMfaOtpHelper,
  getDeviceTokenUrl,
  updateNonMfaConsentUrl,
  getNonMfaUserProfileUrl,
} from './offers.helpers';

import {getAPICall, postAPICall} from '../../services/apiCallsHandler';

import axios from 'axios';
import {call} from 'redux-saga/effects';

export function* loadOffersService(customerId) {
  const offers = yield call(
    getAPICall,
    getAllOffersForMFACustomerUrl(customerId),
    {
      isCallBack: true,
      errorTag: 'GET_ALL_OFFERS',
      logInfoMsg: 'load all offers for mfa customer',
      redirectToOops: false,
    },
    {}
  );
  return offers;
}

export function* loadOffersForNonMfaCustomersService({stateName, isCorporate}) {
  const offers = yield call(
    getAPICall,
    getOffersForNonMFACustomerUrl(stateName, isCorporate),
    {
      isCallBack: true,
      errorTag: 'GET_ALL_NON_MFA_OFFERS',
      logInfoMsg: 'load all offers for non mfa customer',
      redirectToOops: false,
    },
    {}
  );

  return offers;
}

export function* loadOfferByIdNonMfaCustomersService(offerId) {
  const offer = yield call(
    getAPICall,
    getOffersForNonMFACustomerByIdUrl(offerId),
    {
      isCallBack: true,
      errorTag: 'GET_ALL_NON_MFA_OFFERS',
      logInfoMsg: 'load offer by id for non mfa customer',
      redirectToOops: false,
    },
    {}
  );

  return offer;
}
export function* loadPersonalOffersService(customerId) {
  const offers = yield call(
    getAPICall,
    getPersonalOfferLetterDataUrl(customerId),
    {
      isCallBack: true,
      errorTag: 'GET_PERSONAL_OFFERS',
      logInfoMsg: 'load personal offers letter for  customer',
      redirectToOops: false,
    },
    {}
  );
  return offers;
}
export function* loadPreviouslySubmittedNonMFAoffers(customerId) {
  const previouslySubmittedOffers = yield call(
    getAPICall,
    getprevouslySubmittedNonMFAoffersURL(),
    {
      isCallBack: true,
      errorTag: 'GET_PREVIOUSLY_SUBMITTED_NON_MFA_OFFERS',
      logInfoMsg: 'load load Previously Submitted Non MFA offers',
      redirectToOops: false,
    },
    {}
  );
  return previouslySubmittedOffers;
}
export function* submitOffersService(payload) {
  const offers = yield call(
    postAPICall,
    getUrlToSubmitMfaCustomerOffer(payload.customerId),
    payload,
    {
      isCallBack: true,

      errorTag: 'SUBMIT_OFFERS',
      logInfoMsg: 'submit offers for mfa customer',
      redirectToOops: false,
    }
  );
  return offers;
}

export function* submitRecommendedImplementsEnquiry(payload) {
  const enquiry = yield call(
    postAPICall,
    getUrlToSubmitRecommendedImplementOfferEnquiry(payload.customerId),
    payload,
    {
      isCallBack: true,

      errorTag: 'SUBMIT_Recommended_implements_OFFERS',
      logInfoMsg: 'submit offers from personalized letter ',
      redirectToOops: false,
    }
  );
  return enquiry;
}

export function* updateCustomerPersonalOfferStatusService(customerId, payload) {
  const enquiry = yield call(
    postAPICall,
    getPersonalOfferLetterDataUrl(customerId),
    payload,
    {
      isCallBack: true,

      errorTag: 'UPDATE_PERSONAL_OFFER_STATUS',
      logInfoMsg: 'updating personal offers status for user  ',
      redirectToOops: false,
    }
  );
  return enquiry;
}

export function* getNonMfaUserProfileService() {
  const profile = yield call(
    getAPICall,
    getNonMfaUserProfileUrl(),
    {
      isCallBack: true,
      errorTag: 'GET_NON_MFA_USER_PROFILE',
      logInfoMsg: 'fetching non-MFA user profile',
      redirectToOops: false,
    },
    {}
  );
  return profile;
}

export function* getOtpForNonMFAUser(payload) {
  let res = {};
  try {
    res = yield call(nonMfaOtpHelper, 'sentOtp', payload);
    res = {statusCode: res.status, data: res.data};
  } catch (error) {
    res = {statusCode: error.response.status, data: error.response.data};
  }

  return res;
}

export function* verifyOtpForNonMFAUser(payload) {
  let res = {};
  try {
    res = yield call(nonMfaOtpHelper, 'verifyOtp', payload);
    res = {statusCode: res.status, data: res.data};
  } catch (error) {
    res = {statusCode: error.response.status, data: error.response.data};
  }

  return res;
}

export function* getDeviceTokenForUser(customerID) {
  const deviceToken = yield call(
    getAPICall,
    getDeviceTokenUrl(customerID),
    {
      isCallBack: true,
      errorTag: 'GET_DEVICE_TOKEN',
      logInfoMsg: 'load user device token',
      redirectToOops: false,
    },
    {}
  );
  return deviceToken;
}

export function* persistConsentService(payload) {
  let res = {};
  try {
    const consentUrl = updateNonMfaConsentUrl();
    res = yield call(
      postAPICall,
      consentUrl,
      {
        nonMfaEnquiryConsent: payload.consent,
      },
      {
        isCallBack: true,
        errorTag: 'PERSIST_CONSENT',
        logInfoMsg: 'persist enquiry consent',
        redirectToOops: false,
      }
    );
    res = {statusCode: res.status, data: res.data};
  } catch (error) {
    res = {
      statusCode: error.response?.status || 500,
      data: error.response?.data,
    };
  }

  return res;
}

export function* updateNonMfaWhatsAppOptInService(optIn) {
  let res = {};
  try {
    const consentUrl = updateNonMfaConsentUrl();
    res = yield call(
      postAPICall,
      consentUrl,
      {whatsAppOptIn: optIn},
      {
        isCallBack: true,
        errorTag: 'UPDATE_NON_MFA_WHATSAPP_OPTIN',
        logInfoMsg: 'updating non mfa whatsapp optin',
        redirectToOops: false,
      }
    );
    res = {statusCode: res.status, data: res.data};
  } catch (error) {
    res = {
      statusCode: error.response?.status || 500,
      data: error.response?.data,
    };
  }
  return res;
}

export function storeTokenInSessionStorage(token) {
  sessionStorage.setItem('nonMFAToken', JSON.stringify(token));
}

export function removeTokenFromSessionStorage() {
  sessionStorage.removeItem('nonMFAToken');
}

export function uploadFileinS3(s3UploadData) {
  s3UploadData.forEach(async (file) => {
    let config = {
      headers: {
        'Content-Type': file.contentType,
      },
    };
    await axios
      .put(file.signUrl, file.metaData, config)
      .then(() => {})
      .catch((error) => {});
  });
}
